import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { useState, useCallback, createContext, useContext } from 'react';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ColumnManagerContext = /*#__PURE__*/createContext({});
var ColumnManagerProvider = function ColumnManagerProvider(_ref) {
  var columnDefsProp = _ref.columnDefs,
    onColumnDefsChange = _ref.onColumnDefsChange,
    children = _ref.children;
  var initialColumnDefs = columnDefsProp.map(function (c) {
    return _objectSpread({
      isFiltered: true,
      isVisible: true,
      pinned: false
    }, c);
  });
  var _useState = useState(initialColumnDefs),
    _useState2 = _slicedToArray(_useState, 2),
    columnDefs = _useState2[0],
    setColumnDefs = _useState2[1];
  var updateColumnDefs = useCallback(function (reducer) {
    setColumnDefs(function (prev) {
      var result = reducer(prev);
      onColumnDefsChange && onColumnDefsChange(result);
      return result;
    });
  }, [onColumnDefsChange]);
  var state = {
    columnDefs: columnDefs,
    updateColumnDefs: updateColumnDefs
  };
  var columnsForView = columnDefs.filter(function (c) {
    return c.isVisible;
  }).sort(function (a, b) {
    return a.pinned > b.pinned ? -1 : 1;
  });
  return /*#__PURE__*/React__default.createElement(ColumnManagerContext.Provider, {
    value: state
  }, children(_objectSpread(_objectSpread({}, state), {}, {
    columnDefs: columnsForView
  })));
};
var useColumnManager = function useColumnManager() {
  return useContext(ColumnManagerContext);
};

export { ColumnManagerProvider, useColumnManager };
